module.exports = __webpack_public_path__ + "media/images/vp/icon.heart.red-ed4ba769ed1ca153fb757c24fb2194b5.svg";